<div class="admin-settings-container">
    <div class="header-section">
        <h2>{{ 'admin.components.adminNavigation.settings' | translate }}</h2>
    </div>

    <div class="main-content">
        <mat-card appearance="outlined" class="user-notification">
            <mat-card-header>
                {{
                    'admin.components.appSettings.userNotification.title'
                        | translate
                }}
            </mat-card-header>
            <mat-card-content>
                <form #notificationForm="ngForm" class="user-notification-form">
                    <mat-slide-toggle
                    name="displayUserNotification"
                        [(ngModel)]="notification.displayUserNotification"
                    >
                    {{
                        'admin.components.appSettings.userNotification.toggle'
                            | translate
                    }}
                    </mat-slide-toggle>
                    <mat-form-field>
                        <mat-label>{{
                            'admin.components.appSettings.userNotification.germanTitle'
                                | translate
                        }}</mat-label>
                        <textarea matInput cdkTextareaAutosize
                        #autosize="cdkTextareaAutosize" placeholder="{{
                            'admin.components.appSettings.userNotification.germanPlaceholder'
                                | translate
                        }}"
                        name="germanText"
                        [(ngModel)]="notification.germanText"
                        ></textarea>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>                {{
                            'admin.components.appSettings.userNotification.englishTitle'
                                | translate
                        }}</mat-label>
                        <textarea matInput cdkTextareaAutosize
                        #autosize="cdkTextareaAutosize" placeholder="{{
                            'admin.components.appSettings.userNotification.englishPlaceholder'
                                | translate
                        }}"
                        name="englishText"
                        [(ngModel)]="notification.englishText"
                        ></textarea>
                    </mat-form-field>
                    <mat-card-actions>
                        <button 
                        mat-stroked-button
                        (click)="onSaveButtonPressed()"
                        [disabled]="!notificationForm.dirty"
                        >
                        {{
                            'admin.components.appSettings.userNotification.save'
                                | translate
                        }}
                    </button>
                    </mat-card-actions>
                </form>
            </mat-card-content>
        </mat-card>
    </div>
</div>
